// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_footer__YdBAO{
    width: 100%;
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    min-height: 30px;
    align-items: center;
    padding-bottom: constant(safe-area-inset-bottom, 0px);
    padding-bottom: env(safe-area-inset-bottom, 0px);
}
.footer_logout__elt7F svg {
    height: 3rem !important;
    width: 22px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/footer.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,oCAAoC;IACpC,yCAAyC;IACzC,0BAA0B;IAC1B,kCAAkC;IAClC,0CAA0C;IAC1C,eAAe;IACf,SAAS;IACT,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,qDAAqD;IACrD,gDAAgD;AACpD;AACA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B","sourcesContent":[".footer{\n    width: 100%;\n    background: rgba(255, 255, 255, 0.2);\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    position: fixed;\n    bottom: 0;\n    display: flex;\n    justify-content: space-between;\n    font-size: 14px;\n    min-height: 30px;\n    align-items: center;\n    padding-bottom: constant(safe-area-inset-bottom, 0px);\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n}\n.logout svg {\n    height: 3rem !important;\n    width: 22px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `footer_footer__YdBAO`,
	"logout": `footer_logout__elt7F`
};
export default ___CSS_LOADER_EXPORT___;
